// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainer, GridItem, Hidden } from "@insite/mobius/index";
import { baseGridProps } from "@store/Themes/common/props/baseGrid";
import React from "react";

export interface CategoryDetailsPageContainerStyles {
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
}

export const categoryDetailsPageContainer: CategoryDetailsPageContainerStyles = {
    container: baseGridProps.container,
    mainColumn: {
        width: [12],
        printWidth: 12,
    },
};

const styles = categoryDetailsPageContainer;

const CategoryDetailsPageContainer = ({ id }: WidgetProps) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.mainColumn}>
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: CategoryDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Category Details",
        allowedContexts: ["CategoryDetailsPage"],
    },
};
export default widgetModule;
